import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LucideAngularModule } from 'lucide-angular';
import { SidebarComponent, SidebarMode } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';

declare var initFlowbite: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, LucideAngularModule, SidebarComponent, NavbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  sidebarMode: SidebarMode = 'large';
  showShell = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        this.updateShellVisibility();
        if (isPlatformBrowser(this.platformId) && typeof initFlowbite === 'function') {
          setTimeout(() => initFlowbite(), 100);
        }
      });

    this.updateShellVisibility();

    if (isPlatformBrowser(this.platformId)) {
      const saved = sessionStorage.getItem('admin_tools.sidebar_mode');
      if (saved === 'small' || saved === 'large') this.sidebarMode = saved;
    }
  }

  onSidebarModeChange(mode: SidebarMode): void {
    this.sidebarMode = mode;
  }

  private updateShellVisibility(): void {
    let route = this.activatedRoute.root;
    while (route.firstChild) route = route.firstChild;
    this.showShell = route.snapshot.data['showShell'] !== false;
  }
}
